import { Api } from "@/api";
import { UserLoginType } from "@/DTO";

export const EditAdmin = (user: UserLoginType, id: string, first_name: string, last_name: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `admin/${id}`,
      body: JSON.stringify(
        {
          first_name: first_name,
          last_name: last_name
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ChangePasswordAdmin = (user: UserLoginType, password: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `admin/change-password`,
      body: JSON.stringify(
        {
          password: password
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ChangeStatusAdmin = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `admin/change-status/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const RoleAssignAdmin = (user: UserLoginType, id: string, roleList: string[]) => {
  return new Promise<{
    data: any
  }>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `admin/role-assign/${id}`,
      body: JSON.stringify(
        {
          role: roleList
        }
      ),
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: data.data
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

